import styled from 'styled-components';

export const StyledTechIcon = styled.div`
    max-width: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .icon-tooltip {
        color: white;
        background-color: black;
        font-size: 12px;
        font-weight: 300;
        padding: 5px;
        border: 1px solid white;

        position: absolute;
        top: 140px;
        visibility: hidden;
    }
    &:hover .icon-tooltip {
        visibility: visible;
    }
`;
